import { Clipboard } from '@angular/cdk/clipboard';
import { DialogModule } from '@angular/cdk/dialog';
import {
    DatePipe,
    Location,
    NgOptimizedImage,
    isPlatformBrowser,
} from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { Article } from 'app/models/Article';
import { Suivi } from 'app/models/Suivi';
import { ThemeArticle } from 'app/models/ThemeArticle';
import { Utilisateur } from 'app/models/Utilisateur';
import { LinkService } from 'app/shared/Link.service';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { SharedModule } from 'app/shared/shared.module';
import { SuiviService } from 'app/shared/suivi.service';
import { isToday } from 'app/utils/date.utils';
import { environment } from 'environments/environment';
import { Subject, Subscription } from 'rxjs';
import { ImageComponent } from '../../image/image.component';
import { NewsletterComponent } from '../newsletter/newsletter.component';
import { RecommendationArticleComponent } from '../recommendation-article/recommendation-article.component';
import { StatsCardsComponent } from '../stats-cards/stats-cards.component';
import { MetaService } from './../../../shared/meta.service';
import { ShareService } from './../../../shared/share.service';
import { Error404Component } from 'app/modules/error/error-404/error-404.component';

@Component({
    selector: 'app-article',
    templateUrl: './article.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgOptimizedImage,
        MatButtonModule,
        DialogModule,
        MatSidenavModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatTooltipModule,
        SharedModule,
        DatePipe,
        MatPaginatorModule,
        MatTableModule,
        NewsletterComponent,
        RecommendationArticleComponent,
        ImageComponent,
        StatsCardsComponent,
        RouterModule
    ],
    providers: [DatePipe, ConvertToSlugPipe],
})
export class ArticleComponent implements OnInit, OnDestroy {
    html: SafeHtml = '';
    cloud_front = environment.cloud_front_host;
    serveur_name = environment.serveur_name;
    host_name = environment.host_name;
    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    article: Article;
    user: Utilisateur;
    routeSub: Subscription;
    idArticle: any;
    nbAbonneUtilisateurs = {};
    nbAbonnementUtilisateurs = {};
    idUtilisateurConnecte: string = '';
    isLogged: boolean;
    username: string;
    selectedButton = {};
    abonnement = {};
    suivi: Suivi = new Suivi();
    resultat: number;
    nbPublication: number;
    ThemeArticle = ThemeArticle;
    nbArticle: number;
    nbArticleValide: number;
    listeArticles: Article[];
    showCheck: boolean = false;
    showSocials: boolean = false;
    articlesRecommendes: Article[];
    showCustom404 = false; 
    isSlugValid = true;  

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        public location: Location,
        public shareService: ShareService,
        public suiviService: SuiviService,
        private _changeDetectorRef: ChangeDetectorRef,
        private route: ActivatedRoute,
        private router: Router,
        private datePipe: DatePipe,
        private loginService: LoginService,
        private sanitizer: DomSanitizer,
        private metaService: MetaService,
        private seoService: LinkService,
        private clipboard: Clipboard,
        private convertToSlug: ConvertToSlugPipe
    ) {}
    yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
    formatDate(date): string {
        const created = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm');
        let fecha = new Date(created);
        let today = new Date();
        let yesterday = ((d) => new Date(d.setDate(d.getDate() - 1)))(
            new Date()
        );

        if (isToday(today, fecha))
            return this.datePipe.transform(fecha, 'H:mm');
        if (isToday(yesterday, fecha)) return 'Hier';
        return this.datePipe.transform(fecha, 'd MMMM ');
    }

    ngOnInit(): void {
  
            this.routeSub = this.route.params.subscribe((params) => {
                this.idArticle = params['id'];
                const [article, user, slugValid] = this.route.snapshot.data['article'];           
                this.article = article;
                this.user = user;
                this.isSlugValid = slugValid;
                
                // Cas 1 : ID invalide (tronqué/manquant) => 404
                // Cas 2 : Article non trouvé => 404
                // Cas 3 : Slug invalide mais article existe => 404 soft
                this.showCustom404 = !this.article || !this.isSlugValid || !this.idArticle;
            
                // Option : Log des URLs invalides pour analyse
                if (this.showCustom404) {
                    console.warn('URL invalide détectée :', {
                        url: window.location.pathname,
                        expectedSlug: this.article?.nom ? this.convertToSlug.transform(this.article.nom) : null,
                        actualSlug: params['nom'],
                        idValid: !!this.idArticle && /^[\w-]{20,24}$/.test(this.idArticle)
                    });
                }
                this.articlesRecommendes = this.route.snapshot.data['recommendations'];
                this.metaService.updateMetaTags({
                    title: this.article.nom,
                    description: this.article.description,
                    auteur: this.user?.userName,
                    section: ThemeArticle[this.article?.themeArticle],
                    ogTitle: this.article.nom,
                    ogType: 'article',
                    ogUrl:
                        environment.apiUrl +
                        '/actualites/articles/' +
                        this.convertToSlug.transform(this.article.nom) +
                        '/' +
                        this.idArticle,
                    ogDescription: this.article.description,
                    ogImage: this.cloud_front + this.article.image,
                    publishedTime: this.article.date,
                    twitterTitle: this.article.nom,
                    twitterDescription: this.article.description,
                    twitterImage: this.cloud_front + this.article.image,
                    modifiedTime: this.article.date,
                });
    
                this.html = this.sanitizer.bypassSecurityTrustHtml(
                    this.article.contenu
                );
                this._changeDetectorRef.markForCheck();
            });
        this.loginService;
        this.isLogged = this.loginService.getIsLogged();
        this.createLinkForCanonicalURL();

    }

    createLinkForCanonicalURL() {
        this.seoService.createLinkForCanonicalURL();
    }
    shareFacebook() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/articles/' +
            this.convertToSlug.transform(this.article.nom) +
            '/' +
            this.idArticle; // URL of the content to share
        this.shareService.shareOnFacebook(shareUrl);
    }
    shareLinkedin() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/articles/' +
            this.convertToSlug.transform(this.article.nom) +
            '/' +
            this.idArticle; // URL of the content to share
        this.shareService.shareOnLinkedIn(shareUrl);
    }
    copyClipboard() {
        const shareUrl =
            environment.apiUrl +
            '/actualites/articles/' +
            this.convertToSlug.transform(this.article.nom) +
            '/' +
            this.idArticle;
        this.clipboard.copy(shareUrl);
        this.showCheck = true;
        if (isPlatformBrowser(this.platformId))
            setTimeout(() => {
                this.showCheck = false;
                this._changeDetectorRef.markForCheck();
            }, 1000);
    }

    redirectionProfil(idAuteur) {
        this.router.navigate(['/mur-utilisateur-autre', idAuteur]);
    }
    redirectionMonProfil() {
        this.router.navigate(['/mur-utilisateur-connecte']);
    }
    retour() {
        this.location.back();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    toggleShowSocials() {
        this.showSocials = !this.showSocials;
    }

    hideSocials() {
        this.showSocials = false;
    }
}
